import React from 'react'
import styles from "./standardPlan.module.css"
import {ReactComponent as RupeeSvg} from "../../../images/paymentPlan/rupeeWhite.svg"
import plansRightCheckSvg from "../../../images/paymentPlan/plansRightCheck1.jpg";
import { StandardPlanData } from '../../../data/PaymentPlan/StandardPlanData';

const StandardPlan = () => {
    return (
        <div className ={styles.standardPlanContainer} >
            <div className={styles.PlanNameContainer}>
                <p className={styles.PlanName} > Standard</p>
            </div>
            <div className={styles.pricingContainer} >
                <p className={styles.pricingdetails} > Ideal for growing teams for better customer engagement </p>
                <div className='d-flex align-items-center  gap-1' >
                    {/* <img src={rupeeSvg} alt='rupee' className={styles.rupee} /> */}
                    <RupeeSvg className={styles.rupee}  />
                    <p className={styles.amount} > 4,199/-</p>
                </div>
                <p className={styles.pricingdetails} style={{fontWeight:700}} >( Per Month )</p>
            </div>
            <div className={styles.conversationContainer} >
                <p className={styles.conversation} > 5000 Conversations / Month</p>
                <p className={styles.rechargeText}> Additional users licence <br/> @  <span style={{fontWeight:700}} >₹1000 </span> /Month per user </p>
            </div>
            <div  className='d-flex justify-content-center'>
                <div style={{background:"#D9D9D9", width:"85%", height:"1px"}} ></div>
            </div>
            <div className={styles.serviceContainer} >
                <p className={`${styles.services} my-1 `} >Services Included</p>
                <div className='d-flex align-items-start gap-2 mb-2 ' >
                    <p className={styles.servicesListItem} >everything in Growth +</p>
                </div>

                    {StandardPlanData.map((data, index)=>(
                         <div className='d-flex align-items-start gap-2 my-2 ' key={index} >
                         <img src={plansRightCheckSvg} alt='plans' title='RightCheck'  className={styles.plansCheck}  />
                         <p className={styles.servicesListItem} >{data}</p>
                     </div>
                    ))}

                
            </div>
        </div>
      )
}

export default StandardPlan